/* Cross-edition add-on in the order box (2026-10-06). Keeps the summary, mobile bar and button total in step
   with the combined cart (the 30/45 ₪ automatic discounts count decks across editions). */
(function(){
  var xs=document.getElementById('xs'),form=document.getElementById('buyForm');
  function xq(){var r=xs&&xs.querySelector('input[name="xq"]:checked');return r?Number(r.value):0}
  window.ynXsItems=function(){var q=xq();return q?[{id:Number(xs.getAttribute('data-vid')),quantity:q}]:[]};
  if(!xs||!form)return;
  var sum=document.getElementById('sum'),bb=document.getElementById('bbTxt'),amt=document.getElementById('buyAmt');
  function upd(){
    var t=form.querySelector('#tiers input:checked');if(!t)return;
    var q=Number(t.value),x=xq(),n=q+x,w=t.getAttribute('data-word'),tot=t.getAttribute('data-total');
    if(x){
      tot=Math.round((Number(xs.getAttribute('data-self'))*q+Number(xs.getAttribute('data-unit'))*x-(n>=3?4500:n===2?3000:0))/100);
      w+=xs.getAttribute('data-plus').replace('{q}',x);
    }
    if(sum)sum.innerHTML=xs.getAttribute('data-pre')+w+' <b>'+tot+' ₪</b>';
    if(bb)bb.innerHTML=w+'<b>'+tot+' ₪</b>';
    if(amt)amt.textContent=tot+' ₪';
  }
  form.addEventListener('change',upd);
  window.ynXsReset=function(){var z=xs.querySelector('input[value="0"]');if(z){z.checked=true;upd()}};
})();
